import { create } from 'zustand'

export const useTitleStore = create((set) => ({
   titleName: '',
   setTitle: (state) => set( {
         titleName : state
    }),
}))